import { usePreferredShippingMethodWithConfigurations as usePreferredShippingMethodWithConfigurationsBase } from '@monofront/business/hooks/usePreferredShippingMethodWithConfigurations';
import { useLocalOrRemoteCustomer } from './useLocalOrRemoteCustomer';

/**
 * Wrapper hook that uses useLocalOrRemoteCustomer to get customer data
 * and returns the preferred shipping method with configurations.
 */
export const usePreferredShippingMethodWithConfigurations = () => {
  const { resolvedCustomer: customer } = useLocalOrRemoteCustomer();

  return usePreferredShippingMethodWithConfigurationsBase({
    address: customer?.address ?? null,
    preferredShippingMethod: customer?.preferredShippingMethod ?? null,
  });
};
